import { computed, Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';

import { PrivilegeService } from 'shared/services/privilege.service';

@Directive({
	selector: '[appPrivilegeGuard]',
	standalone: true,
})
export class PrivilegeGuardDirective {
	private readonly privilegeService = inject(PrivilegeService);
	private readonly templateRef = inject(TemplateRef);
	private readonly viewContainer = inject(ViewContainerRef);

	appPrivilegeGuard = input<string | string[]>([]);

	private hasAccess = computed(() => {
		const privileges = this.appPrivilegeGuard();
		return [privileges].flat().length === 0 || this.privilegeService.hasPrivilege(privileges)();
	});

	constructor() {
		effect(() => (this.hasAccess() ? this.show() : this.hide()));
	}

	private show(): void {
		if (this.viewContainer.length === 0) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}

	private hide(): void {
		this.viewContainer.clear();
	}
}
